import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-tabs');

window.KFTabs = window.KFTabs || {
  isInitalized: false,
  elements: document.querySelectorAll(getClass()),
  init() {
    if (this.isInitalized) return;
    this.isInitalized = true;
    [].forEach.call(this.elements, (el) => this.setupTabs(el));
  },
  setupTabs(el: Element) {
    if (!el) return;

    const tabHeaders = el.querySelectorAll<HTMLElement>(getClass('header'));
    const tabContents = el.querySelectorAll<HTMLElement>(getClass('content'));

    [].forEach.call(tabHeaders, (tabHeader: HTMLElement) => {
      tabHeader.addEventListener('click', () => {
        const id = tabHeader.dataset.id;

        if (!id) return;

        [].forEach.call(tabHeaders, (tabHeader: HTMLElement) => {
          tabHeader.classList.remove('active');
          tabHeader.setAttribute('tabindex', '0');
        });
        tabHeader.classList.add('active');

        [].forEach.call(tabContents, (tabContent: HTMLElement) => {
          if (tabContent.dataset.id === id) {
            tabContent.classList.add('active');
          } else {
            tabContent.classList.remove('active');
          }
        });
      });

      tabHeader.addEventListener('keydown', (e) => {
        switch (e.code) {
          case 'ArrowRight': {
            const nextTab = tabHeader.nextElementSibling as HTMLElement;

            if (nextTab) {
              nextTab.focus();
            }
            break;
          }
          case 'ArrowLeft': {
            const prevTab = tabHeader.previousElementSibling as HTMLElement;

            if (prevTab) {
              prevTab.focus();
            }
            break;
          }
          case 'Space':
          case 'Enter': {
            e.preventDefault();
            tabHeader.click();
            break;
          }
        }
      });
    });
  },
};

window.KFTabs.init();

export {};
